export default __webpack_public_path__ + "static/media/dash.f3c78d20.svg";